'use client'

import GridFinderLogo from '@/components/icons/logos/gridfinder'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

function GridFinderBadge() {
  return (
    <span className="flex size-4 shrink-0 items-center justify-center [&_svg]:h-full [&_svg]:w-full">
      <GridFinderLogo />
    </span>
  )
}

export default function DriverDisplayIdentifierSelect({
  options = [],
  value,
  onValueChange,
  className,
  compact = false,
  inline = false,
  description,
  label = 'Display names',
}) {
  if (options.length === 0) {
    return null
  }

  const selectedOption =
    options.find((option) => option.value === value) || options[0]

  return (
    <div
      className={cn(
        'flex gap-2',
        inline ? 'flex-wrap items-center' : 'flex-col',
        compact && !inline && 'items-start desktop-xs:items-end',
        className,
      )}
    >
      {label || description ? (
        <div
          className={cn(
            'flex flex-col gap-1',
            compact && !inline && 'desktop-xs:items-end desktop-xs:text-right',
          )}
        >
          {label ? (
            <label
              className={cn(
                'text-sm font-semibold text-neutral-blue-300',
                inline && 'font-normal text-neutral-blue-500',
              )}
            >
              {label}
            </label>
          ) : null}
          {description ? (
            <p className="text-sm text-neutral-blue-400">{description}</p>
          ) : null}
        </div>
      ) : null}

      <div
        className={cn(
          'w-full max-w-sm',
          compact && !inline && 'desktop-xs:w-72',
          inline && 'w-auto min-w-56',
        )}
      >
        <Select value={value} onValueChange={onValueChange}>
          <SelectTrigger
            className={cn(
              'h-12 border-neutral-blue-600 bg-neutral-blue-800 hover:bg-neutral-blue-700',
              inline &&
                'h-[52px] rounded-sm border-neutral-blue-700 px-6 hover:bg-neutral-blue-700',
            )}
          >
            <div className="flex min-w-0 items-center gap-3">
              {selectedOption?.value === 'gf_name' ? <GridFinderBadge /> : null}
              <span className="truncate text-sm font-semibold text-shades-0">
                {selectedOption?.label || 'Select a driver field'}
              </span>
            </div>
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                <div className="flex items-center gap-2">
                  {option.value === 'gf_name' ? <GridFinderBadge /> : null}
                  <span>{option.label}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
